const pub = {
  "pub.whatsapp_default_msg": "Salve, sono interessato/a a un trattamento presso la Esteva Clinic.",
  "pub.error_title": "Si è verificato un errore",
  "pub.error_message": "Si prega di ricaricare la pagina. Se il problema persiste, disattivare la traduzione/le estensioni del browser.",
  "pub.error_reload": "Ricarica la pagina",
  "pub.pill_1": "Impianti dentali Albania",
  "pub.pill_2": "Trapianto di capelli FUE",
  "pub.pill_3": "Rinoplastica correzione del naso",
  "pub.pill_4": "Aumento del seno",
  "pub.pill_5": "Lifting del viso",
  "pub.pill_6": "Liposuzione",
  "pub.pill_7": "Faccette corone in zirconia",
  "pub.pill_8": "Botox acido ialuronico",
  "pub.pill_9": "Addominoplastica",
  "pub.pill_10": "Turismo medico Albania",
  "pub.pill_11": "70% più economico della Svizzera",
  "pub.pill_12": "Clinica premium Tirana",
  "pub.country_albania": "Albania",
  "pub.opening_hours_default": "Lun–Ven: 08:00–20:00 | Sab: 09:00–16:00 | Dom: Chiuso",
  "pub.fkw_1": "Impianti dentali Albania",
  "pub.fkw_2": "Corone in zirconia",
  "pub.fkw_3": "Faccette",
  "pub.fkw_4": "Sbiancamento dei denti",
  "pub.fkw_5": "Trapianto di capelli FUE",
  "pub.fkw_6": "Aumento del seno Albania",
  "pub.fkw_7": "Rinoplastica correzione del naso",
  "pub.fkw_8": "Botox Tirana",
  "pub.fkw_9": "Liposuzione Albania",
  "pub.fkw_10": "Lifting del viso",
  "pub.fkw_11": "Addominoplastica",
  "pub.fkw_12": "Lifting del seno",
  "pub.fkw_13": "Riduzione del seno",
  "pub.fkw_14": "Chirurgia delle palpebre",
  "pub.fkw_15": "BBL Albania",
  "pub.fkw_16": "Chirurgia intima",
  "pub.fkw_17": "Chirurgia plastica Albania",
  "pub.fkw_18": "Chirurgia estetica Tirana",
  "pub.fkw_19": "Turismo medico Albania",
  "pub.fkw_20": "Turismo dentale",
  "pub.fkw_21": "70% più economico della Svizzera",
  "pub.fkw_22": "70% più economico della Germania",
  "pub.fkw_23": "Dentista all'estero",
  "pub.fkw_24": "Clinica premium Tirana",
  "pub.fkw_25": "Prima consulenza gratuita",
};

export default pub;
